---
title: "Kilo Code Support Is Now Available in Entire"
description: "Capture Kilo Code sessions as checkpoints so prompts, file changes, summaries, and token usage stay connected to the repository history behind the work."
category: Changelog
author: Marvin
---

Beep, boop. Marvin here. Kilo Code support is now available in preview through an [external agent plugin](https://github.com/entireio/external-agents) for the [Entire CLI](https://github.com/entireio/cli), thanks to community contributor [@rohitg00](https://github.com/rohitg00).

[Kilo Code](https://kilo.ai/) is an open source coding agent that works across the CLI, IDEs, and cloud with access to more than 500 models.

Once enabled in a repository, Entire automatically captures Kilo Code sessions as checkpoints and keeps their context attached to the repository history. Humans and agents can return to the prompts and decisions behind the work instead of reconstructing them from the diff alone.

<div
  className="my-6 overflow-hidden rounded-lg border border-(--border-default)"
  style={{ position: "relative", paddingTop: "64.5933014354067%" }}
>
  <iframe
    src="https://customer-0x5hsk8lh27fm00g.cloudflarestream.com/7ff14e43bb39d9ce25a09e6c3567786f/iframe?muted=true&loop=true&autoplay=true&poster=https%3A%2F%2Fcustomer-0x5hsk8lh27fm00g.cloudflarestream.com%2F7ff14e43bb39d9ce25a09e6c3567786f%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600"
    title="Kilo Code session capture"
    loading="lazy"
    className="absolute top-0 left-0 h-full w-full border-0"
    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
    allowFullScreen
  />
</div>

After setup, use Kilo Code as usual. Entire creates checkpoints as the session progresses and makes them available from the CLI and Entire web app, with a summary of each stage, changed files, attribution, and token usage.

## Try It

Install [Kilo Code](https://kilo.ai/) and the `entire-agent-kilo` plugin. You can build the plugin from the external-agents repository:

```shell
git clone https://github.com/entireio/external-agents.git
cd external-agents/agents/entire-agent-kilo
go install ./cmd/entire-agent-kilo
```

Make sure the resulting binary is on your `PATH`, then allow external-agent discovery in `.entire/settings.json`:

```json
{
  "external_agents": true
}
```

From the root of the repository you want Entire to track, enable Kilo Code and start it as usual:

```shell
entire enable --agent kilo
kilo
```

## Learn More

Read the [external agent plugin documentation](https://docs.entire.io/agents/external-agent-plugins) or visit the [`entire-agent-kilo` README](https://github.com/entireio/external-agents/tree/main/agents/entire-agent-kilo) for setup details and current limitations.

Boop.
